import { useTranslation } from "react-i18next";
import { Badge } from "@/shared/components/ui/badge";
import { statusLabelKey } from "./format-user";

interface UserStatusBadgeProps {
  readonly isActive: boolean;
}

export function UserStatusBadge({ isActive }: UserStatusBadgeProps) {
  const { t } = useTranslation();
  return (
    <Badge
      data-testid={`user-status-${isActive ? "active" : "deactivated"}`}
      variant={isActive ? "success" : "secondary"}
    >
      {t(statusLabelKey(isActive))}
    </Badge>
  );
}
